// Supervisor-only Jira card copy and helpers (JIRA_DECISION_SPEC "Supervisor card").
// Kept apart from recruiterQaFormat.js: this copy is addressed to the
// supervisor (spec-mandated "נסה שוב"), not to recruiters.
export const JIRA_STATUS_LABELS = {
  planning: 'בתכנון',
  astra_pending: 'ממתינה לבדיקה אוטומטית',
  waiting_for_approval: 'ממתינה לאישור שלך',
  executing: 'בביצוע',
  review: 'ממתינה לבדיקה',
  closed: 'הושלמה',
  failed: 'הטיפול במשימה נכשל',
  cancelled: 'בוטלה'
}

/** Plain-language task status; Astra-pending approval reads as the automatic check. */
export const jiraStatusLabel = jira => {
  if (!jira) return ''
  const key = jira.status_key
  if (key === 'waiting_for_approval' && jira.approval && jira.approval.astra_pending) return JIRA_STATUS_LABELS.astra_pending
  return JIRA_STATUS_LABELS[key] || String(jira.status || '')
}

/** Status tag colour on the supervisor list (Bulma tag modifier per status). */
export const JIRA_STATUS_TAG_CLASS = {
  planning: 'is-light',
  astra_pending: 'is-info',
  waiting_for_approval: 'is-warning',
  executing: 'is-info',
  review: 'is-warning',
  closed: 'is-success',
  failed: 'is-danger',
  cancelled: 'is-light'
}

export const JIRA_STATUS_UNAVAILABLE = 'הסטטוס אינו זמין כרגע'

export const jiraStatusTagClass = jira => {
  if (!jira) return 'is-light'
  const key = jira.status_key
  if (key === 'waiting_for_approval' && jira.approval && jira.approval.astra_pending) return JIRA_STATUS_TAG_CLASS.astra_pending
  return JIRA_STATUS_TAG_CLASS[key] || 'is-light'
}

export const JIRA_ACTIONS = ['approve', 'reject', 'edit']

export const JIRA_ACTION_LABELS = {
  approve: 'אשר לביצוע',
  reject: 'החזר לתכנון',
  edit: 'בקש שינויים'
}

export const JIRA_DECIDED_TEXT = {
  approve: 'הבקשה אושרה לביצוע.',
  reject: 'הבקשה חזרה לתכנון.',
  edit: 'התבקשו שינויים בבקשה והיא חזרה לתכנון.'
}

export const JIRA_COPY = {
  openInJira: 'פתח בג׳ירה',
  readFailure: 'לא ניתן לטעון כרגע',
  retry: 'נסה שוב',
  loading: 'טוען את המשימה…',
  approveConfirm: 'לאשר את התוכנית המוצגת ולהעביר את המשימה לביצוע?',
  astraOverride: 'אישור ידני יעביר את המשימה לביצוע ללא המתנה לבדיקה האוטומטית.',
  rejectPrompt: 'מה הסיבה?',
  editPrompt: 'מה צריך לשנות בבקשה?',
  editHelper: 'ההנחיות יתווספו לבקשה הקיימת, והמשימה תחזור לתכנון.',
  pending: 'ההחלטה נשלחה. מוודאים שהתקבלה…',
  checkAgain: 'בדוק שוב',
  stale: 'המשימה השתנתה מאז שפתחת אותה. יש לעיין בעדכון לפני שליחה מחדש.',
  // Same wording as the recruiter's supervisor_note for each action.
  decided: action => JIRA_DECIDED_TEXT[action] || '',
  unconfirmed: 'לא ניתן לוודא שההחלטה התקבלה — בדקו בג׳ירה',
  showMore: 'הצג עוד',
  showLess: 'הצג פחות',
  cancel: 'ביטול',
  noDraft: 'אין עדיין תוכנית להצגה.',
  acceptanceCriteria: 'תנאי קבלה',
  risks: 'סיכונים',
  openQuestions: 'שאלות פתוחות',
  proposedSolution: 'הפתרון המוצע'
}

/** Server-provided actions, filtered to the three shipped in this release. */
export const jiraAllowedActions = jira => {
  const list = (jira && jira.approval && Array.isArray(jira.approval.allowed_actions)) ? jira.approval.allowed_actions : []
  return JIRA_ACTIONS.filter(a => list.indexOf(a) !== -1)
}
